import { useState } from "react";
import { Card, CardBody, CardHeader, Table, Button, Spinner, Alert } from "reactstrap";
import CommodityModal from "./CommodityModal";
import { withNamespaces } from "react-i18next";
import ProducerMapModal from "./ProducerMapModal";
import { RiMapPinLine } from "react-icons/ri";
import { useQuery } from "@tanstack/react-query";
import SupplierProductService from "src/modules/3rd-party-management/apis/common/SupplierProductService";
import { toast } from "react-toastify";
import { EMPTY_LIST } from "src/common/constants";

const CommoditiesList = ({ supplierId, onProductLoaded, t }) => {
    const [selectedCommodity, setSelectedCommodity] = useState(null);

    const {
        isFetching: productsAreFetching,
        data: products
    } = useQuery({
        queryKey: [
            '3rd-party-management-fetch-supplier-eudr-products-list',
            supplierId
        ],
        queryFn: async () => {
            const service = SupplierProductService.getInstance();

            return await service.list(supplierId, {
                pageIndex: 1,
                pageSize: 1000,
                eudrQuestionnaire: true
            });
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t('An error occurred while fetching products list.'), {
                type: 'error'
            });
        },
        onSuccess: ({ products: result }) => {
            onProductLoaded && onProductLoaded(result)
        }
    });

    return (
        <>
            <Card className="mb-3 shadow-sm">
                <CardHeader>{t('Commodities Summary')}</CardHeader>
                <CardBody>
                    <Alert
                        color="info"
                    >
                        {t('Only products included in the EUDR list with geolocation data are displayed here.')}
                    </Alert>
                    <Table bordered hover responsive>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{t('NACE Code')}</th>
                                <th>{t('Product Name')}</th>
                                <th>{t('Commodity')}</th>
                                <th>{t('Description')}</th>
                                <th>{t('HS Code')}</th>
                                <th>{t('Net Weight (kg)')}</th>
                                <th>{t('Map')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productsAreFetching ? (
                                <tr>
                                    <td colSpan='8' className="text-center">
                                        <Spinner 
                                            size="sm"
                                            color="primary"
                                            className="me-1"
                                        />
                                        {t('Loading...')}
                                    </td>
                                </tr>
                            ) : (
                                !products?.products?.length ? (
                                    <tr>
                                        <td colSpan='8' className="text-center">
                                            {t(EMPTY_LIST)}
                                        </td>
                                    </tr>
                                ) : (
                                    <>
                                        {products.products.map((c, idx) => (
                                            <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>{`${c.name.class} - ${t(c.name.name)}`}</td>
                                                <td>{c.productName}</td>
                                                <td>{c.commodity}</td>
                                                <td>{c.description}</td>
                                                <td>{c.hsCode}</td>
                                                <td>{c.metricTonnes}</td>
                                                <td>
                                                    {/* <Button 
                                                        color="info" 
                                                        size="sm" 
                                                        onClick={() => setSelectedCommodity(c)}
                                                    >
                                                        View Producers ({c.producers.length})
                                                    </Button> */}
                                                    {c.geolocationReference ? (
                                                        <Button
                                                            color="info"
                                                            size="sm"
                                                            onClick={() => setSelectedCommodity(c)}
                                                        >
                                                            <RiMapPinLine />
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            color="secondary"
                                                            size="sm"
                                                            disabled
                                                            title={'No geolocation data available'}
                                                        >
                                                            <i className="ri-map-pin-line"></i> N/A
                                                        </Button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                )
                            )}
                        </tbody>
                    </Table>
                </CardBody>
            </Card>

            {/* <CommodityModal 
                isOpen={!!selectedCommodity}
                toggle={() => setSelectedCommodity(null)}
                commodity={selectedCommodity}
            /> */}
            <ProducerMapModal 
                isOpen={!!selectedCommodity}
                toggle={() => setSelectedCommodity(null)}
                producer={selectedCommodity}
            />
        </>
    );
};

export default withNamespaces()(
    CommoditiesList
);
